import api from '../../../../../helpers/apiRequester'
import { ApiResponse, ClientData } from './types'
import { transformSearchResultToClientData } from './utils'

export interface ClientSearchOptions {
    email?: string
    phone?: string
    dob?: string
    firstName?: string
    lastName?: string
}

export interface ClientSearchResult {
    success: boolean
    totalResults: number
    results: ClientData[]
    errors?: any
}

/**
 * Performs a unified client search using the provided search term
 * Returns standardized ClientData objects regardless of the source system
 */
export const performClientSearch = async (options: ClientSearchOptions): Promise<ClientSearchResult> => {
    const { email, phone, firstName, lastName } = options

    const hasEmail = !!email?.trim()
    const hasPhone = !!phone?.trim()
    const hasFirstName = !!firstName?.trim()
    const hasLastName = !!lastName?.trim()
    const hasName = hasFirstName && hasLastName

    if ((hasFirstName || hasLastName) && !hasName) {
        return {
            success: false,
            totalResults: 0,
            results: [],
            errors: 'Both first and last name are required when searching by name',
        }
    }

    if (!hasEmail && !hasPhone && !hasName) {
        return {
            success: false,
            totalResults: 0,
            results: [],
            errors: 'Email address, phone number, or first and last name must be provided to perform a search',
        }
    }

    try {
        const apiResult = await api({
            url: 'unified-client-search',
            data: {
                email: options.email,
                phone: options.phone,
                dob: options.dob,
                firstName: options.firstName,
                lastName: options.lastName,
            },
        })

        console.log('apiResult.data', apiResult.data)
        const response: ApiResponse = apiResult.data

        if (typeof response.totalResults !== 'number') {
            return {
                success: false,
                totalResults: 0,
                results: [],
                errors: response.errors || 'Search failed',
            }
        }

        return {
            success: true,
            totalResults: response.totalResults,
            results: (response.results || []).map(transformSearchResultToClientData),
            errors: response.errors,
        }
    } catch (error: any) {
        return {
            success: false,
            totalResults: 0,
            results: [],
            errors: error?.response?.data || error?.message || 'An error occurred during search',
        }
    }
}
